export default __webpack_public_path__ + "static/media/ministry-logo.258bba5d.png";